import tw from "twin.macro";

export const Spacing32 = tw.div`mt-32`;
export const Spacing12 = tw.div`mt-12`;
export const Spacing8 = tw.div`mt-8`;
export const Image = tw.img`w-full rounded-10`;
export const Unknown = tw.div`h-12 bg-shade-100!`;
